import axios from 'axios';

function processResponse(result) {
  return result.then((response) => 
          ( response ))
          .catch((error) => 
          ({ error }));
}

const api = (baseUrl, headers) => ({
  
  get(endpoint) {
    const response = axios.get(endpoint, {
      // cancelToken: source.token,
      baseURL: baseUrl,
      headers
    });

    return processResponse(response);
  },
  post(endpoint, params, headers) {
    const response = axios.post(endpoint, params, { 
      baseURL: baseUrl,
      headers
    });
    return processResponse(response);
  },
  put(endpoint, params) {
    const response = axios.put(endpoint, params, {
      baseURL: baseUrl,
    });

    return processResponse(response);
  },
  delete(endpoint, params) {
    const response = axios.delete(endpoint, {
      baseURL: baseUrl,
      params,
    });

    return processResponse(response);
  },
});

export default api;
